import React, { useState } from 'react';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { useApiClient } from '@marageti/z4-lib';
import { FEATURES, useFeatureFlag } from '../../../store/contexts/feature-flags';
import { PecvInferenceResult } from './pecv-types';
import PecvIndicatorView from './pecv-indicator-view';

const PecvIndicatorContainer = ({
  initialPecv,
  tripRequest,
}: {
  initialPecv: number | undefined,
  tripRequest: TripRequest,
}) => {
  const apiClient = useApiClient();
  const canViewInferenceDetails = useFeatureFlag(FEATURES.PECV_INFERENCE_DETAILS);
  const [open, setOpen] = useState(false);
  const [inferenceResult, setInferenceResult] = useState<PecvInferenceResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  if (initialPecv == null) return null;

  const fetchInferenceResult = async () => {
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const result = await apiClient.instance.get<PecvInferenceResult>(`/v3/trip_requests/${tripRequest.id}/inference_results/PECV/latest`);
      setInferenceResult(result);
    } catch (e) {
      const apiError = e as { code?: number, response?: { status?: number } };
      const status = apiError.code || apiError.response?.status;
      setInferenceResult(null);
      setErrorMessage(status === 404
        ? 'No PECV inference result was found for this trip request.'
        : 'PECV inference details could not be loaded.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);

    if (!inferenceResult && !isLoading) {
      fetchInferenceResult();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <PecvIndicatorView
      canViewInferenceDetails={canViewInferenceDetails}
      errorMessage={errorMessage}
      inferenceResult={inferenceResult}
      initialPecv={initialPecv}
      isLoading={isLoading}
      open={open}
      tripRequest={tripRequest}
      onClose={handleClose}
      onOpen={handleOpen}
    />
  );
};

export default PecvIndicatorContainer;
